import { render, staticRenderFns } from "./PartyList.vue?vue&type=template&id=515ca048&"
import script from "./PartyList.vue?vue&type=script&lang=js&"
export * from "./PartyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports